<div class="p-4 d-flex flex-column align-items-center text-center">
  <app-spinner *ngIf="!data?.noSpinner"></app-spinner>
  <b class="mt-4">{{ data?.title }}</b>
  <div [innerHTML]="data?.content" class="mt-1"></div>
  <div class="mt-4" *ngIf="data?.action">
    <app-button variant="ghost-primary" (click)="actionClicked()">
      {{ data.action.label }}
    </app-button>
  </div>
</div>
